import { useHospitalDetailContext } from '../hospital-detail-context'

import { HospitalOfficeHours } from '@/features/hospital/components/hostpial-office-hours'

export const HospitalDetailOfficeHours = () => {
  const { hospital } = useHospitalDetailContext()

  return (
    <HospitalOfficeHours
      officeHours={hospital.officeHours.officeHours}
      comment={hospital.officeHours.officeHoursComment}
    />
  )
}
